export default __webpack_public_path__ + "static/media/Futuresoft_logo.5017ee81.jpg";